import { topics } from "@/mocks/leakHome";

export default function HotTopics() {
  return (
    <section id="topics" className="w-full bg-[#faf8f4] py-10 md:py-14">
      <div className="mx-auto grid max-w-[1280px] gap-6 px-4 lg:grid-cols-[1.15fr_1fr] md:px-6">
        {/* 话题榜 */}
        <div className="rounded-3xl border border-stone-100 bg-white p-5 md:p-7">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs font-bold tracking-widest text-red-500">HOT TOPICS</p>
              <h2 className="mt-1 text-2xl font-black text-stone-800">今日在聊榜</h2>
            </div>
            <span className="flex items-center gap-1.5 rounded-full bg-amber-100 px-3 py-1.5 text-xs font-bold text-amber-700">
              <i className="ri-fire-fill text-amber-500"></i>实时热度
            </span>
          </div>

          <div className="mt-6 space-y-1">
            {topics.map((t, i) => (
              <a
                key={t.name}
                href="#feed"
                className="group flex items-center gap-3 rounded-xl px-3 py-2.5 transition hover:bg-red-50"
              >
                <span
                  className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-lg text-sm font-black ${
                    i < 3 ? "bg-red-600 text-white" : "bg-stone-100 text-stone-400"
                  }`}
                >
                  {i + 1}
                </span>
                <span className="flex-1 truncate text-sm font-semibold text-stone-700 group-hover:text-red-700">
                  {t.name}
                </span>
                <span className="flex items-center gap-1 text-xs font-medium text-red-500">
                  <i className="ri-fire-line"></i> {t.heat}
                </span>
                <span className="hidden w-14 text-right text-xs font-semibold text-emerald-600 sm:block">
                  {t.trend}
                </span>
              </a>
            ))}
          </div>
        </div>

        {/* 侧边：投稿引导 + 私信提示 */}
        <div className="flex flex-col gap-6">
          <div className="relative overflow-hidden rounded-3xl bg-red-700 p-6 text-white md:p-8">
            <div className="absolute -right-6 -top-6 h-40 w-40 rounded-full bg-amber-400/30 blur-2xl"></div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-white/15 px-3 py-1 text-xs font-semibold">
              <i className="ri-megaphone-line"></i> 想上热榜？自己投一个
            </span>
            <h3 className="mt-4 text-2xl font-black leading-snug">你手上那条瓜，<br />可能就是明天的第一。</h3>
            <p className="mt-3 text-sm leading-relaxed text-red-100">
              投稿不用实名，选中合适分区，审核通过立即上榜开吃。
            </p>
            <a
              href="#faq"
              className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-amber-400 px-5 py-2.5 text-sm font-bold text-red-950 transition hover:bg-amber-300"
            >
              匿名投稿 <i className="ri-send-plane-fill"></i>
            </a>
          </div>

          <div className="flex items-center gap-4 rounded-3xl border border-red-100 bg-red-50/60 p-5 md:p-6">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-white text-red-600">
              <i className="ri-chat-private-line text-xl"></i>
            </span>
            <div>
              <h3 className="text-base font-bold text-stone-800">悄悄话走私信</h3>
              <p className="mt-1 text-sm text-stone-500">
                不方便公开的，私信发给小编，同样 100% 匿名保护。
              </p>
            </div>
            <a
              href="#faq"
              className="ml-auto hidden shrink-0 items-center gap-1 whitespace-nowrap text-sm font-bold text-red-600 hover:text-red-700 sm:flex"
            >
              私信小编 <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}